import React from 'react';

const AuthNavButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
  children,
  ...props
}) => (
  <button
    type="button"
    className="rounded-md border-none bg-gray-100 px-4 py-2 text-sm font-medium text-gray-900 shadow-none hover:bg-gray-200 dark:bg-neutral-800 dark:text-white dark:hover:bg-neutral-700"
    {...props}
  >
    {children}
  </button>
);

export default AuthNavButton;
